<template>
  <div>
    <PageAllow controller="Receipt" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <!-- 要货商/供应商/调拨仓库 -->
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.title") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="
                    billEntity.actions &&
                    billEntity.actions.check_bill &&
                    $permission.permissionAllow('Receipt', 'checkBill') &&
                    billEntity.status != 3
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    checkBillMemo = billEntity.memo;
                    billCheckDialog = true;
                  "
                >
                  <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                  {{ $t("Receipt.bill_check") }}
                </v-btn>
                <v-btn
                  v-if="
                    billEntity.actions &&
                    billEntity.actions.uncheck_bill &&
                    $permission.permissionAllow('Receipt', 'uncheckBill')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="unBillCheckDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                  {{ $t("Receipt.uncheck_bill") }}
                </v-btn>
                <v-btn
                  v-if="
                    billEntity.actions
                      ? billEntity.actions.credential_refresh
                      : ''
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="refreshDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-sync-alt</v-icon>
                  {{ $t("ReceiptDetail.update_credential_type") }}
                </v-btn>
                <v-btn
                  v-if="$permission.permissionAllow('Receipt', 'detailExport')"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="download()"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("ReceiptDetail.receipt_detail_export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />

          <v-expansion-panel-content>
            <v-row
              no-gutters
              class="mt-4 table-style"
              v-if="billEntity.bill_obj_type == 1"
            >
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("ReceiptDetail.Fields.importers", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.name }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.tel }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.memo && billEntity.memo.length < 6">{{
                    billEntity.memo
                  }}</span>
                  <span v-else>
                    <v-tooltip top max-width="480">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{
                            billEntity.memo
                              ? billEntity.memo.substr(0, 6) + "..."
                              : ""
                          }}
                        </span>
                      </template>
                      <span>
                        {{ billEntity.memo }}
                      </span>
                    </v-tooltip>
                  </span>
                  <v-icon
                    x-small
                    @click.stop="billCheckMemoDialog = true"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="mt-4 table-style"
              v-if="billEntity.bill_obj_type == 2"
            >
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.name }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.tel }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ billEntity.memo }} </span
                  ><v-icon
                    x-small
                    @click.stop="billCheckMemoDialog = true"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="mt-4 table-style"
              v-if="billEntity.bill_obj_type == 3"
            >
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.supplier") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity">
                    {{
                      billEntity.stock_name +
                      "(" +
                      billEntity.stock_code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.name }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.tel }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ billEntity.memo }} </span
                  ><v-icon
                    x-small
                    @click.stop="billCheckMemoDialog = true"
                    class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 收付款流水 + 活动记录 -->
      <v-expansion-panels
        v-model="panelsDetail"
        multiple
        accordion
        class="mt-4"
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.Fields.turnover") }}
              <v-spacer />

              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="completeDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-receipt</v-icon>
                  {{ $t("ReceiptDetail.complete") }}
                </v-btn>

                <v-btn
                  small
                  color="orange"
                  class="px-2 me-2 mb-1 elevation-1"
                  v-if="
                    billEntity.bill_type == 102 &&
                    online_return_flg == 1 &&
                    $permission.permissionAllow('Receipt', 'refund') &&
                    lakalapay_enable
                  "
                  :dark="
                    billEntity.order_status == 3 || billEntity.order_status == 4
                  "
                  @click.stop="
                    onlineReturnDialog = true;
                    online_bill_record =
                      online_bill_records && online_bill_records.length == 1
                        ? online_bill_records[0]
                        : null;
                    onlineReturnPrice = null;
                    billEntityOnlineReturn = Object.assign(
                      {},
                      JSON.parse(JSON.stringify(billEntity)),
                      {
                        bill_record_time: new Date()
                          .toISOString()
                          .substr(0, 10),
                      }
                    );
                  "
                  :disabled="
                    !(
                      billEntity.order_status == 3 ||
                      billEntity.order_status == 4
                    )
                  "
                >
                  <v-icon x-small class="pe-1">fa-receipt</v-icon>
                  {{ $t("ReceiptDetail.online_return") }}
                </v-btn>
                <v-btn
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="
                    addDialog = true;
                    billEntity = Object.assign(
                      {},
                      JSON.parse(JSON.stringify(billEntity)),
                      {
                        bill_record_time: new Date()
                          .toISOString()
                          .substr(0, 10),
                        price:
                          billEntity.bill_type == 101 ||
                          billEntity.bill_type == 202
                            ? billEntity.total_price -
                                (billEntity.up_sum - billEntity.down_sum) >=
                              0
                              ? $numberFormatter.formatMoney(
                                  billEntity.total_price -
                                    (billEntity.up_sum - billEntity.down_sum)
                                )
                              : 0
                            : billEntity.total_price -
                                (billEntity.down_sum - billEntity.up_sum) >=
                              0
                            ? $numberFormatter.formatMoney(
                                billEntity.total_price -
                                  (billEntity.down_sum - billEntity.up_sum)
                              )
                            : 0,
                        pay_type:
                          $permission.permissionAllow(
                            'Shops',
                            'getShopBalanceHistories'
                          ) && billEntity.bill_obj_type == 1
                            ? '101'
                            : '102',
                      }
                    );
                  "
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("ReceiptDetail.add") }}
                </v-btn>
                <v-btn
                  v-if="
                    billEntity &&
                    billEntity.actions &&
                    billEntity.actions.sub_account_cancel_refund
                  "
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="lklSubAccountCancelRefund(billEntity.id)"
                >
                  <v-icon x-small class="pe-1">fa-receipt</v-icon>
                  {{ $t("ReceiptDetail.lklSubAccountCancelRefund") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-card-text>
              <!-- 101 202 -->
              <v-row
                dense
                v-if="
                  billEntity.bill_type == 101 || billEntity.bill_type == 202 || billEntity.bill_type == 301
                "
              >
                <v-col cols="12" sm="6" md="3" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.bill_check_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.bill_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.credential_type")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.credential_str }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2" v-if="thirdOrder">
                  <span>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.serve_fee")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ thirdOrder.service_fee | formatMoney }}
                    <v-btn
                      v-if="thirdOrder.service_fee_status"
                      small
                      disabled
                      class="px-2 me-2 mb-1 elevation-1"
                    >
                      {{ $t("ReceiptDetail.paid_serve_fee") }}
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      dark
                      color="primary"
                      class="px-2 me-2 mb-1 elevation-1"
                      target="_blank"
                      @click.stop="payServeDialog = true"
                      :href="payServeFee"
                    >
                      <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                      {{ $t("ReceiptDetail.pay_serve_fee") }}
                    </v-btn>
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.fee_total")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.net_receipt")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{
                      (billEntity.up_sum - billEntity.down_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="billEntity.wait_io_type == 3">
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.waite_refund")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <a @click="price_memo_dialog = true">
                      {{ $t("Global.money") }}
                      {{ billEntity.wait_pay_price | formatMoney }}
                    </a>
                  </span>
                  <span v-else>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.wait_receive")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <a @click="price_memo_dialog = true">
                      {{ $t("Global.money") }}
                      {{ billEntity.wait_receive_price | formatMoney }}
                    </a>
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2" v-if="billEntity.pay_type == 1">
                  <span>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.personal_pay")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.personal_pay_price | formatMoney }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="billEntity.bill_type == 101 && billEntity.return_price"
                >
                  <span>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.refund_sum")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ $t("Global.money") }}
                    {{ billEntity.return_price | formatMoney }}
                  </span>
                </v-col>
              </v-row>
              <!-- 102 201 -->
              <v-row
                dense
                v-if="
                  billEntity.bill_type == 102 || billEntity.bill_type == 201 || billEntity.bill_type == 203 || billEntity.bill_type == 302
                "
              >
                <v-col cols="12" sm="6" md="3" class="text-no-wrap">
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.bill_check_code") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>{{ billEntity.bill_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.credential_type")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.credential_str }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.pay_fee_total")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.paid_in")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{
                      (billEntity.down_sum - billEntity.up_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="billEntity.wait_io_type == 1">
                    <!-- billEntity.down_sum -
                        billEntity.up_sum -
                        billEntity.total_price >=
                      0 -->
                    <span
                      class="font-weight-bold me-2"
                      v-if="
                        billEntity.total_price <
                        billEntity.down_sum - billEntity.up_sum
                      "
                      >{{ $t("ReceiptDetail.waite_refund")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span class="font-weight-bold me-2" v-else
                      >{{ $t("ReceiptDetail.wait_receive")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_receive_price | formatMoney }}
                  </span>
                  <span v-else>
                    <span class="font-weight-bold me-2"
                      >{{ $t("ReceiptDetail.wait_pay")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_pay_price | formatMoney }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>

            <v-row no-gutters>
              <v-spacer />
            </v-row>
            <v-data-table :headers="headers" :items="bill_records">
              <template v-slot:item.actions="{ item }">
                <!-- 红冲 -->
                <v-tooltip
                  top
                  v-if="$permission.permissionAllow('Receipt', 'offsetting')"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.actions.reverse"
                      small
                      dark
                      v-bind="attrs"
                      v-on="on"
                      color="danger"
                      class="px-2 me-2"
                      @click.stop="
                        offSettingDialog = true;
                        currentItem = JSON.parse(JSON.stringify(item));
                        currentItem = Object.assign({}, currentItem, {
                          bill_record_time: new Date()
                            .toISOString()
                            .substr(0, 10),
                        });
                      "
                    >
                      {{ $t("ReceiptDetail.reverse") }}
                    </v-btn>
                  </template>
                  <span>{{ $t("ReceiptDetail.reverse") }}</span>
                </v-tooltip>
                <!-- 退款 -->
                <v-tooltip
                  top
                  v-if="$permission.permissionAllow('Receipt', 'refund')"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.actions.refund"
                      small
                      dark
                      v-bind="attrs"
                      v-on="on"
                      color="action"
                      class="px-2 me-2"
                      @click.stop="
                        refundDialog = true;
                        pay_price = item.price;
                        wait_pay_price =
                          (item.pay_type == 230 || item.pay_type == 231) &&
                          settings &&
                          settings.sub_account_modify_enable == 1 &&
                          settings.lkl_sub_account_enable == 1
                            ? null
                            : billEntity.wait_pay_price;
                        currentItem = Object.assign(
                          {},
                          JSON.parse(JSON.stringify(item)),
                          {
                            bill_record_time: new Date()
                              .toISOString()
                              .substr(0, 10),
                            wait_refund_price: $numberFormatter.formatMoney(
                              item.price - item.return_price
                            ),
                          }
                        );
                        currentItemLock = JSON.parse(
                          JSON.stringify(currentItem)
                        );
                      "
                    >
                      {{ $t("ReceiptDetail.operation_type") }}
                    </v-btn>
                  </template>
                  <span>{{ $t("ReceiptDetail.operation_type") }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.images="{ item }">
                <v-img
                  v-for="(img, i) in item.img_url"
                  :key="i"
                  :src="img"
                  width="40"
                  height="40"
                  style="float: left"
                  @click.stop="$showFullscreenImages(item.img_url, i)"
                >
                </v-img>
                <v-icon
                  x-small
                  class="pt-2 pb-1 primary--text"
                  @click.stop="
                    imagesDialog = true;
                    currentItem = item;
                  "
                >
                  fa-edit
                </v-icon>
              </template>
              <template v-slot:item.cash_discount="{ item }">
                <span v-if="item.cash_discount && item.cash_discount > 0">
                    {{ $t("Global.money") }}{{ item.cash_discount | formatMoney }}
                </span>
              </template>
              <template v-slot:item.voucher_code="{ item }">
                <span class="text-no-wrap">
                  {{ item.voucher_code }}
                </span>
              </template>
              <template v-slot:item.memo="{ item }">
                <v-icon
                  x-small
                  @click.stop="
                    memo_dialog_memo = item.memo;
                    memo_dialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                  v-if="item.memo"
                >
                  fa-edit
                </v-icon>
              </template>

              <template v-slot:item.bill_record_code="{ item }">
                <div class="d-flex flex-row justify-end align-center">
                  <div class="mr-4">
                    <span v-if="item.operation_type == 203">
                      <v-chip
                        small
                        label
                        :color="item.operation_type | operationTypeColor"
                        :text-color="
                          item.operation_type | operationTypeTextColor
                        "
                      >
                        {{ item.operation_type | operationTypeText }}
                      </v-chip>
                    </span>
                    <span v-if="item.operation_type == 901">
                      <v-chip
                        small
                        label
                        :color="item.operation_type | operationTypeColor"
                        :text-color="
                          item.operation_type | operationTypeTextColor
                        "
                      >
                        {{ item.operation_type | operationTypeText }}
                      </v-chip>
                    </span>
                  </div>
                  <div>
                    <span class="text-no-wrap caption font-weight-bold">
                      {{ item.bill_record_code }}
                    </span>
                    <br />
                    <span
                      class="text-no-wrap caption secondary--text"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                    >
                      {{ item.created | formatTime }}
                    </span>
                  </div>
                </div>
              </template>
              <!-- 收款 -->
              <template v-slot:item.collection="{ item }">
                <span v-if="item.io_type == 1">
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <!-- 付款 -->
              <template v-slot:item.pay="{ item }">
                <span v-if="item.io_type == 2">
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panelsDetail.find((p) => p == 1)
                    ? null
                    : panelsDetail.push(1);
                "
              >
                {{ $t("ReceiptDetail.activities.title") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 对账单明细 -->
      <v-expansion-panels v-model="Detail" multiple accordion class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.Fields.receipt_detail") }}
              <span v-if="billEntity.bill_type == 101" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.order") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 102" class="pl-1">
                {{
                  "(" +
                  $t("ReceiptDetail.Fields.shop_return", [$consts.shopName()]) +
                  ")"
                }}
              </span>
              <span v-if="billEntity.bill_type == 201" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.purchase") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 202" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.purchase_return") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 301" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.requisition") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 302" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.requisitionPay") + ")" }}
              </span>
              <v-spacer />
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.obj") }}{{ $t("Global.colon") }}</span
                  >
                  <span v-if="billEntity.bill_obj_type == 1 && billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                  <span v-if="billEntity.bill_obj_type == 2 && billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                  <span v-if="billEntity.bill_obj_type == 3">
                    {{
                      billEntity.stock_name +
                      "(" +
                      billEntity.stock_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 101"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.org_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      style="text-decoration: none"
                      :href="'/#/orders/' + billEntity.order_id"
                    >
                      {{ billEntity.org_code }}
                    </a></span
                  >
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 102"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.return_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <a
                    style="text-decoration: none"
                    :href="'/#/return-orders/' + billEntity.order_id"
                  >
                    {{ billEntity.org_code }}
                  </a>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 201"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.in_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ billEntity.org_code }}
                    <span v-if="billEntity.stock_order.bill_purchase">
                      (
                      {{ billEntity.stock_order.bill_purchase.purchase_code }}
                      )
                    </span>
                  </span>
                  <v-chip
                    v-if="billEntity.cancel_flg || billEntity.all_loss_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                  <span v-if="billEntity.all_loss_flg" class="red--text">
                    [{{ $t("ReceiptDetail.Fields.normal_four") }}]
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 202"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.out_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.org_code }}</span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 301 || billEntity.bill_type == 302"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.requisitions_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      style="text-decoration: none"
                      :href="'/#/requisitions/' + billEntity.requisition_id"
                    >
                      {{ billEntity.org_code }}
                    </a>
                  </span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                  >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 1"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span
                    >{{ $t("Global.money")
                    }}{{ billEntity.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{
                      (billEntity.order_discount && billEntity.order_discount)
                          ? ((billEntity.fee + billEntity.order_discount) -
                              billEntity.logistics_fee -
                              billEntity.service_charge)
                          : (billEntity.fee -
                              billEntity.logistics_fee -
                              billEntity.service_charge)
                        | formatMoney
                    }}
                    )
                  </span>
                  <span v-if="settings && settings.order_discount && billEntity.order_discount && billEntity.order_discount > 0">
                   <span class="red--text">
                    (&nbsp;{{
                        $t("ReceiptDetail.order_discount") +
                        $t("Global.colon") +
                        $t("Global.money")
                      }}
                   </span>
                    <span class="red--text">
                      {{ (billEntity.order_discount > 0) ? ('-' + billEntity.order_discount) : 0 | formatMoney}}&nbsp;)
                    </span>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 2"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{ billEntity.fee | formatMoney }} )
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 3"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")}}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.fee | formatMoney }} )
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  :md="billEntity.relation_order ? 4 : 8"
                  v-if="billEntity.bill_obj_type == 1"
                ></v-col>
                <v-col cols="12" sm="6" md="4" v-if="billEntity.relation_order">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReturnOrder.Fields.for_order_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <a
                    style="text-decoration: none"
                    :href="'/#/orders/' + billEntity.relation_order.id"
                  >
                    {{ billEntity.relation_order.order_code }}
                  </a>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 1"
                >
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text">
                    {{ $t("Global.money")
                    }}{{ billEntity.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (&nbsp;{{
                      $t("ReceiptDetail.logistics_fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.logistics_fee | formatMoney }}&nbsp;)
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  :md="billEntity.relation_order ? 4 : 8"
                  v-if="
                    billEntity.bill_obj_type == 1 &&
                    settings &&
                    settings.service_charge_enable
                  "
                ></v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    billEntity.relation_order && billEntity.relation_order.bill
                  "
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReturnOrder.RelationFields.order_bill")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <!-- <a
                    style="text-decoration: none"
                    :href="'/#/receipts/' + billEntity.relation_order.bill.id"
                  > -->
                  {{ billEntity.relation_order.bill.bill_code }}
                  <!-- </a> -->
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="
                    billEntity.bill_obj_type == 1 &&
                    settings &&
                    settings.service_charge_enable
                  "
                >
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text">
                    {{ $t("Global.money")
                    }}{{ billEntity.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (&nbsp;{{
                      $t("ReceiptDetail.service_charge") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.service_charge | formatMoney }}&nbsp;)
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="
                    billEntity.gross_weight_total &&
                    billEntity.gross_weight_total != ''
                  "
                ></v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="
                    billEntity.gross_weight_total &&
                    billEntity.gross_weight_total != ''
                  "
                >
                  <span v-if="billEntity.bill_obj_type == 1">
                    <span class="transparent--text font-weight-bold me-2">
                      {{ $t("ReceiptDetail.sum_price") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span class="transparent--text">
                      {{ $t("Global.money") }}
                      {{ billEntity.fee | formatMoney }}
                    </span>
                  </span>
                  <span v-if="billEntity.bill_obj_type == 2">
                    <span class="font-weight-bold me-2 transparent--text">
                      {{ $t("ReceiptDetail.sum_price_tax") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span class="transparent--text">
                      {{ $t("Global.money") }}
                      {{ billEntity.total_price | formatMoney }}
                    </span>
                  </span>
                  <span class="red--text">
                    (&nbsp;{{
                      $t("Order.DetailFields.gross_weight") + $t("Global.colon")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.gross_weight_total }}&nbsp;)
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="billEntity.bill_obj_type == 3"
                ></v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 3"
                >
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text">
                    {{ $t("Global.money") }}
                    {{ billEntity.fee | formatMoney }}
                  </span>
                  <span class="red--text">
                    (&nbsp;{{
                      $t("ReceiptDetail.logistics_fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.logistics_fee | formatMoney }}&nbsp;)
                  </span>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="receiptHeaders"
              :items="bill_details"
              :search="search"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n3">
                    <v-row no-gutters>
                      <v-spacer />
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="search"
                          clearable
                          hide-details
                          :label="$t('Search.filter')"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:item.standard_name="{ item }">
                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </template>
              <template v-slot:item.price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.total_num="{ item }">
                <span>
                  {{ item.total_num | formatMoney }}
                </span>
              </template>
              <template v-slot:item.total_price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.before_tax_price="{ item }">
                <span>
                  {{ $t("Global.money")
                  }}{{ item.before_tax_price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.after_tax_price="{ item }">
                <span>
                  {{ $t("Global.money")
                  }}{{ item.after_tax_price | formatMoney }}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <!-- 归账 -->
    <v-dialog persistent v-model="completeDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("$vuetify.alert") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="completeDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("ReceiptDetail.notice") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="completeDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Complete()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 在线退款 -->
    <v-dialog persistent v-model="onlineReturnDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("ReceiptDetail.Fields.pay") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="onlineReturnDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <!-- <ValidationObserver ref="observer"> -->
            <v-form>
              <v-row>
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.receipt.return_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{ billEntityOnlineReturn.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.receipt.accounts_payable")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ billEntityOnlineReturn.total_price | formatMoney }}
                  </span>
                </v-col>

                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.receipt.act_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{
                      (billEntityOnlineReturn.down_sum -
                        billEntityOnlineReturn.up_sum)
                        | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.receipt.not_pay_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="red--text"
                    v-if="
                      billEntityOnlineReturn.total_price -
                        (billEntityOnlineReturn.down_sum -
                          billEntityOnlineReturn.up_sum) >=
                      0
                    "
                  >
                    {{ $t("Global.money")
                    }}{{
                      (billEntityOnlineReturn.total_price -
                        (billEntityOnlineReturn.down_sum -
                          billEntityOnlineReturn.up_sum))
                        | formatMoney
                    }}
                  </span>
                  <span v-else class="red--text">
                    {{ $t("Global.money") }}{{ 0 | formatMoney }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="billEntityOnlineReturn.bill_obj_type == 1"
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntityOnlineReturn.shop">
                    {{
                      billEntityOnlineReturn.shop.shop_name +
                      "(" +
                      billEntityOnlineReturn.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="billEntityOnlineReturn.bill_obj_type == 2"
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntityOnlineReturn.supplier">
                    {{
                      billEntityOnlineReturn.supplier.supplier_name +
                      "(" +
                      billEntityOnlineReturn.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.return_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ billEntityOnlineReturn.org_code }}
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.date")
                    }}{{ $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="billEntityOnlineReturn.bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 付款金额 -->
                <v-col cols="12">
                  <!-- <ValidationProvider
                                        rules="required"
                                    > -->
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.pay_price")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="onlineReturnPrice"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                  <!-- </ValidationProvider> -->
                </v-col>
                <!-- 支付方式 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}
                    {{ $t("ReceiptDetail.backtrack") }}
                    <!-- <v-select
                      style="padding-top: 0px"
                      v-model="billEntity.pay_type"
                      :items="payTypeArr"
                      item-text="value"
                      item-value="key"
                      clearable
                    ></v-select> -->
                  </span>
                </v-col>
                <!-- 原支付流水 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.vouchers") }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="online_bill_record"
                      :items="onlineBillRecordsItems"
                      item-text="Description"
                      item-value="id"
                      return-object
                    ></v-select>
                  </span>
                </v-col>
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="billEntityOnlineReturn.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    return_memo && settings && settings.bill_record_auto_memo
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.auto_memo")
                    }}{{ $t("Global.colon") }}
                    <v-textarea v-model="return_memo" outlined auto-grow>
                    </v-textarea>
                  </span>
                </v-col>
              </v-row>
            </v-form>
            <!-- </ValidationObserver> -->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onlineReturnDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="OnlineReturn()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 追加 -->
    <v-dialog persistent v-model="addDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{
              billEntity.bill_type == 202 ||
              billEntity.bill_type == 101 ||
              billEntity.bill_type == 301
                ? $t("ReceiptDetail.Fields.collection")
                : $t("ReceiptDetail.Fields.pay")
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <!-- <ValidationObserver ref="observer"> -->
            <v-form>
              <v-row>
                <v-col cols="6">
                  <span>
                    {{
                      billEntity.bill_type == 101
                        ? $t("ReceiptDetail.receipt.org_price")
                        : billEntity.bill_type == 102
                        ? $t("ReceiptDetail.receipt.return_price")
                        : billEntity.bill_type == 201
                        ? $t("ReceiptDetail.receipt.pur_price")
                        : billEntity.bill_type == 202
                        ? $t("ReceiptDetail.receipt.return_out_price")
                        : billEntity.bill_type == 301 || billEntity.bill_type == 302
                        ? $t("ReceiptDetail.receipt.requisitions_price")
                        : ""
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span>
                    {{
                      billEntity.bill_type == 101 || billEntity.bill_type == 202 || billEntity.bill_type == 301
                        ? $t("ReceiptDetail.receipt.fee_price")
                        : billEntity.bill_type == 102 ||
                          billEntity.bill_type == 201 ||
                          billEntity.bill_type == 302
                        ? $t("ReceiptDetail.receipt.accounts_payable")
                        : ""
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 101 || billEntity.bill_type == 202 || billEntity.bill_type == 301
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.net_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{
                      (billEntity.up_sum - billEntity.down_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 102 || billEntity.bill_type == 201 || billEntity.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.act_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{
                      (billEntity.down_sum - billEntity.up_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 101 || billEntity.bill_type == 202 || billEntity.bill_type == 301
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.not_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="red--text"
                    v-if="
                      billEntity.total_price -
                        (billEntity.up_sum - billEntity.down_sum) >=
                      0
                    "
                  >
                    {{ $t("Global.money")
                    }}{{
                      (billEntity.total_price -
                        (billEntity.up_sum - billEntity.down_sum))
                        | formatMoney
                    }}
                  </span>
                  <span v-else class="red--text">
                    {{ $t("Global.money") }}{{ 0 | formatMoney }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 102 || billEntity.bill_type == 201 || billEntity.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.not_pay_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    class="red--text"
                    v-if="
                      billEntity.total_price -
                        (billEntity.down_sum - billEntity.up_sum) >=
                      0
                    "
                  >
                    {{ $t("Global.money")
                    }}{{
                      (billEntity.total_price -
                        (billEntity.down_sum - billEntity.up_sum))
                        | formatMoney
                    }}
                  </span>
                  <span v-else class="red--text">
                    {{ $t("Global.money") }}{{ 0 | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 1">
                  <span>
                    {{ $t("ReceiptDetail.receipt.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 2">
                  <span>
                    {{ $t("ReceiptDetail.receipt.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 3">
                  <span>
                    {{ $t("Receipt.Fields.shop_name") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      billEntity.stock_name +
                      "(" +
                      billEntity.stock_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span>
                    {{
                      billEntity.bill_type == 101
                        ? $t("ReceiptDetail.org_code")
                        : billEntity.bill_type == 102
                        ? $t("ReceiptDetail.return_code")
                        : billEntity.bill_type == 201
                        ? $t("ReceiptDetail.in_code")
                        : billEntity.bill_type == 202
                        ? $t("ReceiptDetail.out_code")
                        : (billEntity.bill_type == 301 || billEntity.bill_type == 302)
                        ? $t("ReceiptDetail.requisitions_code")
                        : ""
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ billEntity.org_code }}
                </v-col>
                <!-- 公司名称 -->
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 101 || billEntity.bill_type == 102
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.company_name") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ billEntity.shop.company_name }}
                  </span>
                </v-col>
                <!-- 税号 -->
                <v-col
                  cols="6"
                  v-if="
                    billEntity.bill_type == 101 || billEntity.bill_type == 102
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.national_tax_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ billEntity.shop.national_tax_code }}
                  </span>
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.date")
                    }}{{ $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="billEntity.bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 付款金额 -->
                <v-col cols="12">
                  <!-- <ValidationProvider
                                        rules="required"
                                    > -->
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.pay_price") }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="billEntity.price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                  <!-- </ValidationProvider> -->
                </v-col>
                <!-- 现金折扣 -->
                <v-col cols="12" v-if="settings && settings.cash_discount">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.cash_discount") }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="billEntity.cash_discount"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="billEntity.cash_discount ? (billEntity.cash_discount = $numberFormatter.formatMoney(billEntity.cash_discount)) : ''"
                    />
                  </span>
                </v-col>
                <!-- 支付方式 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method") }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="billEntity.pay_type"
                      :items="payTypeArr"
                      item-text="value"
                      item-value="key"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <v-col cols="12" v-if="billEntity.pay_type == 101">
                  <span>
                    {{ $t("ReceiptDetail.receipt.balance")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{
                      billEntity.shop
                        ? billEntity.shop.balance
                        : "" | formatMoney
                    }}
                  </span>
                  <span v-if="settings && settings.specified_balance_consumption && billEntity.bill_type == 101">
                    （ {{ $t("ReceiptDetail.receipt.specified_balance") }}
                    {{ $t("Global.colon") }}
                    {{ $t("Global.money") }}
                    {{ (billEntity.specified_balance) ? billEntity.specified_balance : 0 | formatMoney }}）
                  </span>
                </v-col>
                <!-- 凭证号 -->
                <v-col
                  cols="12"
                  v-if="
                    billEntity.pay_type != 101 && billEntity.pay_type != null
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.code") }}
                    {{ $t("Global.colon") }}
                    <v-text-field
                      v-model="billEntity.voucher_code"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="billEntity.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
              </v-row>
            </v-form>
            <!-- </ValidationObserver> -->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Confirm()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 退款 -->
    <v-dialog persistent v-model="refundDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("ReceiptDetail.refund.title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="refundDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <!-- 门店名称 -->
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.refund.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <!-- 对账单号 -->
                <v-col cols="6">
                  <span>
                    {{ $t("ReceiptDetail.refund.receipt_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ billEntity.bill_code }}
                </v-col>
                <!-- 支付金额 -->
                <v-col cols="4">
                  <span>
                    {{ $t("ReceiptDetail.refund.payment_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ pay_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 待退金额 -->
                <v-col cols="4">
                  <span>
                    {{ $t("ReceiptDetail.refund.refund_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ billEntity.wait_pay_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 可退金额 -->
                <v-col cols="4">
                  <span>
                    {{ $t("ReceiptDetail.refund.enable_refund_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ currentItem.wait_refund_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.date")
                    }}{{ $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="currentItem.bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                      :disabled="
                        currentItemLock.pay_type == 216 ||
                        currentItemLock.pay_type == 218 ||
                        currentItemLock.pay_type == 219 ||
                        currentItemLock.pay_type == 220
                      "
                    />
                  </span>
                </v-col>
                <!-- 退款金额 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.refund") }}
                    {{ $t("Global.colon") }}
                    <!-- 当支付金额大于待退金额显示待退金额 -->

                    <v-text-field
                      v-if="
                        currentItemLock.pay_type == 216 ||
                        currentItemLock.pay_type == 218 ||
                        currentItemLock.pay_type == 219 ||
                        currentItemLock.pay_type == 220
                      "
                      v-model="currentItem.wait_refund_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      disabled
                    />
                    <v-text-field
                      v-else-if="
                        currentItemLock.pay_type == 230 ||
                        currentItemLock.pay_type == 231
                      "
                      v-model="wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      :disabled="
                        settings &&
                        settings.lkl_sub_account_enable &&
                        settings.lkl_sub_account_enable == 1
                      "
                    />
                    <v-text-field
                      v-else-if="currentItemLock.pay_type == 227"
                      v-model="wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <v-text-field
                      v-else-if="currentItemLock.pay_type == 223"
                      v-model="pay_price"
                      single-line
                      dense
                      hide-details
                      disabled
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <v-text-field
                      v-else-if="currentItemLock.pay_type == 225"
                      v-model="wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <v-text-field
                      v-else-if="currentItemLock.pay_type == 233"
                      v-model="wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <v-text-field
                      v-else-if="pay_price > billEntity.wait_pay_price"
                      v-model="wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <v-text-field
                      v-else
                      v-model="currentItem.price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                    <!-- :value="$numberFormatter.formatTwoDot(currentItem.price)" -->
                  </span>
                </v-col>
                <!-- 支付方式 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.refund_method")
                    }}{{ $t("Global.colon") }}
                    <v-select
                      class="mt-0"
                      v-model="currentItem.pay_type"
                      :items="refundPayArr"
                      item-text="value"
                      item-value="key"
                      dense
                    ></v-select>
                  </span>
                </v-col>
                <!-- 凭证号 -->
                <v-col
                  cols="12"
                  v-if="
                    currentItem.pay_type != 101 &&
                    currentItem.pay_type != 227 &&
                    currentItem.pay_type != null &&
                    currentItemLock.pay_type != 230 &&
                    currentItemLock.pay_type != 231 &&
                    currentItem.pay_type != 233 &&
                    currentItem.pay_type != 235 &&
                    currentItem.pay_type != 237 &&
                    currentItemLock.pay_type != 203 &&
                    currentItemLock.pay_type != 239
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.code") }}
                    {{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.voucher_code"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    currentItemLock.pay_type != 230 &&
                    currentItemLock.pay_type != 231
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    memo &&
                    billEntity.bill_type == 101 &&
                    settings &&
                    settings.bill_record_auto_memo
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.refund.auto_memo")
                    }}{{ $t("Global.colon") }}
                    <v-textarea v-model="memo" outlined auto-grow> </v-textarea>
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="refundDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Refund()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 红冲 -->
    <v-dialog persistent v-model="offSettingDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("ReceiptDetail.offSetting.title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="offSettingDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 1">
                  <span>
                    {{ $t("ReceiptDetail.offSetting.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 2">
                  <span>
                    {{ $t("ReceiptDetail.offSetting.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 1">
                  <span>
                    {{ $t("ReceiptDetail.offSetting.org_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ billEntity.org_code }}
                </v-col>
                <v-col cols="6" v-if="billEntity.bill_obj_type == 2">
                  <span>
                    {{ $t("ReceiptDetail.offSetting.pur_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ billEntity.org_code }}
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.offSetting.date")
                    }}{{ $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="currentItem.bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 付款金额 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.offSetting.pay_price")
                    }}{{ $t("Global.colon") }} {{ $t("Global.money")
                    }}{{ currentItem.price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.offSetting.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="offSettingDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="OffSetting()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 刷新 -->
    <v-dialog persistent v-model="refreshDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("ReceiptDetail.Fields.refresh") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="refreshDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.credential_str")
                    }}{{ $t("Global.colon") }}

                    <v-select
                      style="padding-top: 0px"
                      v-model="billEntity.credential_type"
                      :items="refresh"
                      item-text="value"
                      item-value="key"
                      item-disabled="disabled"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
              </v-row>
            </v-form>
            <h3>{{ $t("ReceiptDetail.refresh_notice") }}</h3>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="refreshDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Refresh()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 三方支付调起弹窗等待确认刷新 -->
    <v-dialog persistent v-model="payServeDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("ReceiptDetail.pay_serve_fee_refresh_title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="payServeDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{
                $t("CRUD.backToList", [
                  $t("ReceiptDetail.pay_serve_fee_refresh_title"),
                ])
              }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <h3>{{ $t("ReceiptDetail.pay_serve_fee_refresh") }}</h3>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            @click="
              getReceiptDetailsFromAPI();
              payServeDialog = false;
            "
            >{{ $t("CRUD.confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 自动备注 -->
    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-truncate" style="max-width: 360px">
            {{ $t("ReceiptDetail.refund.auto_memo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea v-model="memo_dialog_memo" outlined auto-grow readonly />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 待退金额备注 -->
    <v-dialog v-model="price_memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-truncate" style="max-width: 360px">
            {{ $t("ReceiptDetail.refund.diffDetail") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="price_memo_dialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea v-model="price_memo" auto-grow readonly rounded />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click.stop="copyText(price_memo)">
            {{ $t("CRUD.clone") }}
          </v-btn>
          <v-btn color="secondary" outlined @click="price_memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 退款延迟提醒 -->
    <DialogAlert
      v-model="refreshAlertDialog"
      :message="$t('ReceiptDetail.refundSuccess')"
    />
    <MemoDialog
      v-model="billCheckMemoDialog"
      @confirm="
        CheckBillMemoUpdate({ memo: $event });
        billCheckMemoDialog = false;
      "
      :billCheckMemo="billEntity.memo"
    />
    <DialogBillCheck
      v-model="billCheckDialog"
      :label="$t('Receipt.bill_check')"
      @confirm="
        CheckBillMemoUpdate({ memo: $event });
        CheckBill();
        billCheckDialog = false;
      "
      addMemo
      :billCheckMemo="checkBillMemo"
    />
    <DialogBillCheck
      v-model="unBillCheckDialog"
      :label="$t('Receipt.uncheck_bill')"
      @confirm="
        UnCheckBill();
        unBillCheckDialog = false;
      "
    />
    <DialogPostImages
      v-model="imagesDialog"
      :img_url="(currentItem &&
        currentItem.img_url &&
        currentItem.img_url.length > 0) ? currentItem.img_url : []
      "
      :billRecordId="currentItem.id"
      editEnable
      folder_type="bill_records"
      :title="$t('ReceiptDetail.Fields.images_title')"
      @addComfirm="getReceiptDetailsFromAPI()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Receipt from "@/api/receipt";
import MemoDialog from "./plugins/MemoDialog";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import DialogBillCheck from "@/components/plugins/DialogBillCheck";
import DialogPostImages from "./plugins/DialogPostImages"
import Settings from "@/api/settings";
import Orders from "@/api/orders";
import RequestConfigs from "@/api/request_configs";
import DialogAlert from "@/components/plugins/DialogAlert";
import Payment from "@/api/payment";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    DialogAlert,
    MemoDialog,
    DialogBillCheck,
    DialogPostImages,
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    refresh() {
      if (this.settings && this.settings.bill_credential_type_arr) {
        let arr = [];
        for (let index in this.settings.bill_credential_type_arr) {
          let i = {};
          i.key = index;
          i.value = this.settings.bill_credential_type_arr[index];
          arr.push(i);
        }
        return arr.map((e) => {
          const disabled = e.key == "19" ? true : false;
          return Object.assign({}, e, { disabled });
        });
      }
    },
    onlineBillRecordsItems() {
      if (
        this.online_return_flg &&
        this.online_bill_records &&
        this.online_bill_records.length
      ) {
        return this.online_bill_records.map((record) => {
          record.Description = i18n.t("ReceiptDetail.online_bill_records", [
            record.voucher_code,
            record.pay_type_str,
            record.price,
          ]);
          return record;
        });
      } else {
        return [];
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    payTypeArr() {
      if (this.billEntity) {
        let arr = [];
        for (let index in this.billEntity.pay_type_arr) {
          let i = {};
          i.key = index;
          i.value = this.billEntity.pay_type_arr[index];
          arr.push(i);
        }
        // 删除易生退款、汇付退款支付方式
        if (arr.findIndex((item) => item.key == 215) > -1) {
          arr.splice(
            arr.findIndex((item) => item.key == 215),
            1
          );
        }
        if (arr.findIndex((item) => item.key == 217) > -1) {
          arr.splice(
            arr.findIndex((item) => item.key == 217),
            1
          );
        }
        if (
          !this.$permission.permissionAllow("Shops", "getShopBalanceHistories")
        ) {
          if (arr.findIndex((item) => item.key == 101) > -1) {
            arr.splice(
              arr.findIndex((item) => item.key == 101),
              1
            );
          }
        }
        return arr;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    refundPayArr() {
      let arr = [];
      if (
        this.currentItemLock.pay_type == 216 ||
        this.currentItemLock.pay_type == 218 ||
        this.currentItemLock.pay_type == 219 ||
        this.currentItemLock.pay_type == 220
      ) {
        arr.push({
          key: 217,
          value: i18n.t("ReceiptDetail.refundType.original_refund"),
        });
      } else if (this.currentItemLock.pay_type == 223) {
        arr.push({
          key: 223,
          value: i18n.t("ReceiptDetail.refundType.ws_refund"),
        });
      } else if (this.currentItemLock.pay_type == 225) {
        arr.push({
          key: 225,
          value: i18n.t("ReceiptDetail.refundType.hfdg_refund"),
        });
      } else if (this.currentItemLock.pay_type == 227) {
        arr.push({
          key: 227,
          value: i18n.t("ReceiptDetail.refundType.sxf_refund"),
        });
      } else if (
        this.currentItemLock.pay_type == 230 ||
        this.currentItemLock.pay_type == 231
      ) {
        arr.push({
          key: this.currentItemLock.pay_type,
          value: i18n.t("ReceiptDetail.refundType.lkl_refund"),
        });
      } else if (this.currentItemLock.pay_type == 233) {
        arr.push({
          key: 233,
          value: i18n.t("ReceiptDetail.refundType.lcsw_refund"),
        });
      } else if (this.currentItemLock.pay_type == 235) {
        arr.push({
          key: 235,
          value: i18n.t("ReceiptDetail.refundType.wcv3_refund"),
        });
      } else if (this.currentItemLock.pay_type == 237) {
        arr.push({
          key: 237,
          value: i18n.t("ReceiptDetail.refundType.wcb2b_refund"),
        });
      } else if (this.currentItemLock.pay_type == 203) {
        arr.push({
          key: 203,
          value: i18n.t("ReceiptDetail.refundType.wx_refund"),
        });
      } else if (this.currentItemLock.pay_type == 239) {
        arr.push({
          key: 239,
          value: i18n.t("ReceiptDetail.refundType.lcsw_cbk_refund"),
        });
      } else {
        for (let index in this.billEntity.refund_pay_arr) {
          let i = {};
          i.key = Number(index);
          i.value = this.billEntity.refund_pay_arr[index];
          arr.push(i);
        }
        if (
          !this.$permission.permissionAllow("Shops", "getShopBalanceHistories")
        ) {
          arr.splice(0, 1);
        }
      }

      return arr;
    },

    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receipt"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receiptDetail"),
        disabled: true,
        href: "/receipts",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("ReceiptDetail.Fields.bill_record_code"),
          align: "center",
          sortable: false,
          width: 220,
          value: "bill_record_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.pay_type_str"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "pay_type_str",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.collection"),
          align: "center",
          sortable: false,
          value: "collection",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.pay"),
          align: "center",
          sortable: false,
          value: "pay",
        },
     ];
      if (this.settings.cash_discount) {
        headers.push(
          {
            text: i18n.t("ReceiptDetail.receipt.cash_discount"),
            align: "center",
            class: "text-no-wrap",
            sortable: false,
            value: "cash_discount",
          }
        )
      }
      headers.push(
        {
          text: i18n.t("ReceiptDetail.Fields.voucher_code"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "voucher_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.comment"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "comment",
        }
      )
      if (
        this.billEntity.bill_type == 102 &&
        this.billEntity.order_return_type == 2
      ) {
        headers.push({
          text: i18n.t("ReceiptDetail.Fields.origin_bill_record_code"),
          align: "center",
          sortable: false,
          value: "origin_bill_record_code",
        });
      }
      if (
        this.billEntity.bill_type == 101 &&
        this.settings &&
        this.settings.bill_record_auto_memo
      ) {
        headers.push({
          text: i18n.t("ReceiptDetail.refund.auto_memo"),
          align: "center",
          sortable: false,
          value: "memo",
        });
      }
      headers.push({
        text: i18n.t("TableHeaders.actions"),
        align: "center",
        sortable: false,
        value: "actions",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.images"),
        align: "center",
        sortable: false,
        value: "images",
      });
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ReceiptDetail.activities.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ReceiptDetail.activities.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ReceiptDetail.activities.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    receiptHeaders() {
      var receiptHeaders = [
        {
          text: i18n.t("ReceiptDetail.Fields.material_code"),
          align: "center",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.material_name"),
          align: "center",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.standard_name"),
          align: "center",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.unit"),
          align: "center",
          sortable: false,
          value: "unit",
        },
      ];
      if (
        this.settings &&
        this.settings.use_tax == 1 &&
        this.billEntity.bill_type == 201
      ) {
        receiptHeaders.push(
          {
            text: i18n.t("ReceiptDetail.Fields.before_tax_price"),
            align: "center",
            sortable: false,
            value: "before_tax_price",
          },
          {
            text: i18n.t("ReceiptDetail.Fields.after_tax_price"),
            align: "center",
            sortable: false,
            value: "after_tax_price",
          }
        );
      } else {
        receiptHeaders.push({
          text: i18n.t("ReceiptDetail.Fields.price"),
          align: "center",
          sortable: false,
          value: "price",
        });
      }
      receiptHeaders.push({
        text: i18n.t("ReceiptDetail.Fields.total_num"),
        align: "center",
        sortable: false,
        value: "total_num",
      });
      receiptHeaders.push({
        text: i18n.t("ReceiptDetail.Fields.total_price"),
        align: "center",
        sortable: false,
        value: "total_price",
      });
      if (this.settings && this.settings.finance_bill_enable == 1) {
        receiptHeaders.push({
          text: i18n.t("ReceiptDetail.Fields.finance_memo"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "finance_memo",
        });
      }
      return receiptHeaders;
    },
    payServeFee() {
      return this.thirdOrder
        ? RequestConfigs.FengpuURL +
            "alipay/pay_center?account_id=" +
            this.accountID +
            "&order_code=" +
            this.billEntity.org_code
        : "";
    },
    accountID() {
      return this.accountInfo ? this.accountInfo.account_id : "";
    },
    ...mapState(["settings", "accountInfo"]),
  },

  data: () => ({
    currentItem: {},
    currentItemLock: {},
    bill_record_time: new Date().toISOString().substr(0, 10),
    // pay_type: 101,
    pay_price: 0,
    wait_pay_price: 0,

    panels: [0],
    panelsDetail: [0],
    Detail: [0],
    tab: null,
    billEntity: {},
    order_activities: [],
    bill_records: [],
    bill_details: [],
    activities_details: [],
    search: "",
    payServeDialog: false,
    refreshDialog: false,
    refreshAlertDialog: false,
    completeDialog: false,
    addDialog: false,
    refundDialog: false,
    offSettingDialog: false,
    return_price: null,
    price: null,
    thirdAccessToken: "",
    thirdOrder: "",
    online_return_flg: 0,
    online_bill_records: [],
    onlineReturnDialog: false,
    billEntityOnlineReturn: {},
    memo: "",
    memo_dialog_memo: "",
    memo_dialog: false,
    can_refund_sub_json: {},
    return_memo: "",
    online_bill_record: {},
    onlineReturn_can_refund_sub_json: {},
    onlineReturnPrice: null,
    price_memo_dialog: false,
    price_memo: "",
    billCheckMemoDialog: false,
    lakalapay_enable: null,
    billCheckDialog: false,
    unBillCheckDialog: false,
    checkBillMemo: "",
    imagesDialog: false,
  }),

  mounted() {
    this.getReceiptDetailsFromAPI();
    this.getLakalapayFromAPI();
  },

  watch: {
    billEntity: {
      handler() {
        if (
          this.billEntity.org_code &&
          this.billEntity.bill_type == 101 &&
          this.settings &&
          this.settings.push_platform == 1017
        ) {
          Settings.getThirdApiAccessToken().then(
            function (response) {
              if (response.data.status.isOK()) {
                this.thirdAccessToken = response.data.access_token;
                Orders.thirdAPIViewOrder(
                  {
                    account_id: this.accountID,
                    order_code: this.billEntity.org_code,
                  },
                  this.thirdAccessToken
                )
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.thirdOrder = response.data.order;
                      }
                    }.bind(this)
                  )
                  .catch();
              }
            }.bind(this)
          );
        }
      },
    },
    // refundDialog: {
    //   handler() {
    //     if (this.refundDialog) {
    //       if (
    //         this.currentItem.pay_type == 230 ||
    //         this.currentItem.pay_type == 231
    //       ) {
    //         this.wait_pay_price = this.currentItem.wait_refund_price;
    //       }
    //     }
    //   },
    // },
    refundDialog: {
      handler() {
        if (
          this.refundDialog &&
          this.billEntity.bill_type == 101 &&
          this.settings &&
          this.settings.bill_record_auto_memo
        ) {
          Receipt.getAutoMemo(this.billEntity.bill_code).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.memo = response.data.memo;
              }
            }.bind(this)
          );
        }
        if (
          this.refundDialog &&
          (this.currentItem.pay_type == 230 ||
            this.currentItem.pay_type == 231) &&
          this.settings &&
          this.settings.sub_account_modify_enable == 1 &&
          this.settings.lkl_sub_account_enable == 1
        ) {
          Receipt.getRefundFee({
            bill_id: this.billEntity.id,
            bill_record_id: this.currentItem.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.wait_pay_price = response.data.can_refund_price;
                this.can_refund_sub_json = response.data.can_refund_sub_json;
              }
            }.bind(this)
          );
        }
      },
    },
    onlineReturnDialog: {
      handler() {
        if (
          this.onlineReturnDialog &&
          this.settings &&
          this.settings.bill_record_auto_memo
        ) {
          Receipt.getAutoMemo(this.billEntity.bill_code).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.return_memo = response.data.memo;
              }
            }.bind(this)
          );
        }
        if (this.onlineReturnDialog && this.online_bill_record) {
          this.onlineReturnPrice =
            Number(this.online_bill_record.price) -
              Number(this.online_bill_record.return_price) >
            Number(this.billEntityOnlineReturn.total_price) -
              (Number(this.billEntityOnlineReturn.down_sum) -
                Number(this.billEntityOnlineReturn.up_sum))
              ? this.$numberFormatter.formatMoney(
                  Number(this.billEntityOnlineReturn.total_price) -
                    (Number(this.billEntityOnlineReturn.down_sum) -
                      Number(this.billEntityOnlineReturn.up_sum))
                )
              : this.$numberFormatter.formatMoney(
                  Number(this.online_bill_record.price) -
                    Number(this.online_bill_record.return_price)
                );
          if (
            (this.online_bill_record.pay_type == 230 ||
              this.online_bill_record.pay_type == 231) &&
            this.settings &&
            this.settings.sub_account_modify_enable == 1 &&
            this.settings.lkl_sub_account_enable == 1
          ) {
            this.onlineReturnPrice = this.online_bill_record.can_refund_price;
            this.onlineReturn_can_refund_sub_json =
              this.online_bill_record.can_refund_sub_json;
          }
        }
      },
    },
    price_memo_dialog: {
      handler() {
        if (this.price_memo_dialog) {
          var data = { memo_flg: 1, material_code: 1 };
          if (this.billEntity.wait_io_type != 3) {
            data = Object.assign({}, data, { agent_pay: 1 });
          }
          Receipt.getAutoMemo(this.billEntity.bill_code, data).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.price_memo = response.data.memo;
              }
            }.bind(this)
          );
        }
      },
    },
    online_bill_record: {
      handler() {
        if (this.online_bill_record) {
          this.onlineReturnPrice =
            Number(this.online_bill_record.price) -
              Number(this.online_bill_record.return_price) >
            Number(this.billEntityOnlineReturn.total_price) -
              (Number(this.billEntityOnlineReturn.down_sum) -
                Number(this.billEntityOnlineReturn.up_sum))
              ? this.$numberFormatter.formatMoney(
                  Number(this.billEntityOnlineReturn.total_price) -
                    (Number(this.billEntityOnlineReturn.down_sum) -
                      Number(this.billEntityOnlineReturn.up_sum))
                )
              : this.$numberFormatter.formatMoney(
                  Number(this.online_bill_record.price) -
                    Number(this.online_bill_record.return_price)
                );
          if (
            (this.online_bill_record.pay_type == 230 ||
              this.online_bill_record.pay_type == 231) &&
            this.settings &&
            this.settings.sub_account_modify_enable == 1 &&
            this.settings.lkl_sub_account_enable == 1
          ) {
            this.onlineReturnPrice = this.online_bill_record.can_refund_price;
            this.onlineReturn_can_refund_sub_json =
              this.online_bill_record.can_refund_sub_json;
          }
        }
      },
    },
  },

  methods: {
    getReceiptDetailsFromAPI() {
      Receipt.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.billEntity = response.data.billEntity;
            this.bill_records = response.data.billEntity.bill_records;
            this.bill_details = response.data.billEntity.bill_details;
            this.activities_details = response.data.order_activities;
            this.online_return_flg = response.data.billEntity.online_return_flg;
            if (this.online_return_flg) {
              this.online_bill_records =
                response.data.billEntity.relation_order.bill.online_bill_records;
            }
          }
        }.bind(this)
      );
    },

    // 归账
    Complete() {
      this.$store.dispatch("fullscreenLoading");
      Receipt.complete(this.$route.params.id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.completeDialog = false;
              this.getReceiptDetailsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    // 追加
    Confirm() {
      this.$store.dispatch("fullscreenLoading");
      var data = [this.billEntity].map(function (e) {
        return {
          bill_id: e.id,
          bill_record_time: e.bill_record_time,
          pay_type: e.pay_type,
          comment: e.comment,
          voucher_code: e.voucher_code,
          price: e.price,
          cash_discount: e.cash_discount,
        };
      });
      // 指定余额支付逻辑
      if (this.settings && this.settings.specified_balance_consumption && this.billEntity.bill_type == 101 && data[0].pay_type == 101 && (data[0].price > this.billEntity.specified_balance)) {
        this.$snackbar.error(i18n.t("ReceiptDetail.specified_balance"));
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      Receipt.saveBillRecord(data[0])
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.addDialog = false;
              this.getReceiptDetailsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    // 退款
    async Refund() {
      this.$store.dispatch("fullscreenLoading");
      var price = 0;
      if (this.pay_price > this.billEntity.wait_pay_price) {
        price = this.wait_pay_price;
      } else {
        price = this.currentItem.price;
      }
      var bill_record_id = this.billEntity.id;
      var data = {
        bill_id: bill_record_id,
        bill_record_id: this.currentItem.id,
        comment: this.currentItem.comment,
        refund_time: this.currentItem.bill_record_time,
        voucher_code: this.currentItem.voucher_code,
      };
      if (
        this.billEntity.bill_type == 101 &&
        this.settings &&
        this.settings.bill_record_auto_memo
      ) {
        data = Object.assign({}, data, { memo: this.memo });
      }
      if (
        this.currentItemLock.pay_type == 216 ||
        this.currentItemLock.pay_type == 218 ||
        this.currentItemLock.pay_type == 219 ||
        this.currentItemLock.pay_type == 220
      ) {
        data = Object.assign({}, data, {
          price: this.currentItem.wait_refund_price,
          refund_type: 1,
        });
      } else if (this.currentItemLock.pay_type == 223) {
        data = Object.assign({}, data, {
          price: this.currentItem.price,
          refund_type: 1,
        });
      } else if (this.currentItemLock.pay_type == 225) {
        data = Object.assign({}, data, {
          price: this.wait_pay_price,
          refund_type: 1,
          pay_type: this.currentItem.pay_type,
        });
      } else if (
        this.currentItemLock.pay_type == 230 ||
        this.currentItemLock.pay_type == 231
      ) {
        data = Object.assign({}, data, {
          price: this.wait_pay_price,
          refund_type: 1,
          pay_type: this.currentItem.pay_type,
          voucher_code: "",
          comment: "",
        });
        if (
          this.settings &&
          this.settings.sub_account_modify_enable == 1 &&
          this.settings.lkl_sub_account_enable == 1 &&
          this.wait_pay_price > 0 &&
          !Array.isArray(this.can_refund_sub_json)
        ) {
          data = Object.assign({}, data, {
            refund_pay_way_json: this.can_refund_sub_json,
          });
        }
      } else if (this.currentItemLock.pay_type == 203) {
        data = Object.assign({}, data, {
          price: price,
          refund_type: 1,
          pay_type: this.currentItem.pay_type,
          voucher_code: "",
        });
      } else if (this.currentItemLock.pay_type == 239) {
        data = Object.assign({}, data, {
          price: price,
          refund_type: 1,
          pay_type: this.currentItem.pay_type,
          voucher_code: "",
        });
      } else {
        data = Object.assign({}, data, {
          price: price,
          pay_type: this.currentItem.pay_type,
        });
      }
      if (
        this.currentItemLock.pay_type == 227 ||
        this.currentItemLock.pay_type == 233 ||
        this.currentItemLock.pay_type == 235 ||
        this.currentItemLock.pay_type == 237
      ) {
        data = {
          bill_id: bill_record_id,
          bill_record_id: this.currentItem.id,
          price: this.wait_pay_price,
          refund_type: 1,
          pay_type: this.currentItem.pay_type,
          comment: this.currentItem.comment,
          refund_time: this.currentItem.bill_record_time,
        };
      }
      Receipt.refund(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              let _this = this;
              setTimeout(function () {
                _this.refundDialog = false;
                _this.getReceiptDetailsFromAPI();
                _this.$store.dispatch("fullscreenLoadingStop");
                if (
                  _this.currentItemLock.pay_type == 235 ||
                  _this.currentItemLock.pay_type == 237
                ) {
                  _this.refreshAlertDialog = true;
                }
              }, 5000);
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    // 在线退款
    async OnlineReturn() {
      this.$store.dispatch("fullscreenLoading");
      if (!this.online_bill_record) {
        this.$snackbar.error(i18n.t("ReceiptDetail.idError"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else {
        var data = {
          bill_id: this.billEntity.relation_order.bill.id,
          bill_record_id: this.online_bill_record.id,
          comment: this.billEntityOnlineReturn.comment,
          refund_time: this.billEntityOnlineReturn.bill_record_time,
          price: this.onlineReturnPrice,
          voucher_code: this.online_bill_record.voucher_code,
          return_bill_id: this.billEntity.id,
          pay_type: this.online_bill_record.pay_type,
          refund_type: 1,
        };
        if (this.settings && this.settings.bill_record_auto_memo) {
          data = Object.assign({}, data, { memo: this.return_memo });
        }
        if (
          this.settings &&
          this.settings.sub_account_modify_enable == 1 &&
          this.settings.lkl_sub_account_enable == 1 &&
          this.onlineReturnPrice > 0 &&
          !Array.isArray(this.onlineReturn_can_refund_sub_json)
        ) {
          data = Object.assign({}, data, {
            refund_pay_way_json: this.onlineReturn_can_refund_sub_json,
          });
        }
        var priceMax =
          Number(this.online_bill_record.price) -
            Number(this.online_bill_record.return_price) >
          Number(this.billEntityOnlineReturn.total_price) -
            (Number(this.billEntityOnlineReturn.down_sum) -
              Number(this.billEntityOnlineReturn.up_sum))
            ? this.$numberFormatter.formatMoney(
                Number(this.billEntityOnlineReturn.total_price) -
                  (Number(this.billEntityOnlineReturn.down_sum) -
                    Number(this.billEntityOnlineReturn.up_sum))
              )
            : this.$numberFormatter.formatMoney(
                Number(this.online_bill_record.price) -
                  Number(this.online_bill_record.return_price)
              );
        if (Number(this.billEntityOnlineReturn.price) > Number(priceMax)) {
          this.$store.dispatch("fullscreenLoadingStop");
          this.$snackbar.error(i18n.t("ReceiptDetail.errorHint"));
        } else {
          Receipt.refund(data)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  let _this = this;
                  setTimeout(function () {
                    _this.onlineReturnDialog = false;
                    _this.getReceiptDetailsFromAPI();
                    _this.$store.dispatch("fullscreenLoadingStop");
                  }, 2000);
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    // 红冲
    OffSetting() {
      this.$store.dispatch("fullscreenLoading");

      // var date = new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      //   .toISOString()
      //   .substr(0, 10);
      var bill_id = this.billEntity.id;
      var data = [this.currentItem].map(function (e) {
        return {
          bill_id: bill_id,
          bill_record_id: e.id,
          offsetting_time: e.bill_record_time,
          comment: e.comment,
        };
      });
      Receipt.offSetting(data[0])
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.offSettingDialog = false;
              this.getReceiptDetailsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },

    // 刷新
    Refresh() {
      this.$store.dispatch("fullscreenLoading");
      Receipt.refresh({
        id: this.$route.params.id,
        credential_type: this.billEntity.credential_type,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.refreshDialog = false;
              this.getReceiptDetailsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    // 对账单详情导出
    download() {
      Receipt.download(
        Object.assign({
          id: this.$route.params.id,
          time_type: this.$route.query.time_type,
        })
      );
    },
    getLakalapayFromAPI() {
      Payment.fetch({
        keys: ["lakalapay_enable"],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lakalapay_enable = response.data.settings.lakalapay_enable;
          }
        }.bind(this)
      );
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$snackbar.success(i18n.t("ReceiptDetail.copySuccess"));
      } catch (err) {
        this.$snackbar.error(i18n.t("ReceiptDetail.copyfail"));
      }
    },
    CheckBillMemoUpdate(data) {
      Receipt.CheckBillMemoUpdate(this.$route.params.id, data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptDetailsFromAPI();
          }
        }.bind(this)
      );
    },
    CheckBill() {
      this.$store.dispatch("fullscreenLoading");
      Receipt.checkBill(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptDetailsFromAPI();
            this.$snackbar.success(i18n.t("ReceiptDetail.checkSuccess"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    UnCheckBill() {
      this.$store.dispatch("fullscreenLoading");
      Receipt.unCheckBill(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptDetailsFromAPI();
            this.$snackbar.success(i18n.t("ReceiptDetail.unCheckSuccess"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    lklSubAccountCancelRefund(id) {
      this.$store.dispatch("fullscreenLoading");
      Receipt.lklSubAccountCancelRefund({ bill_id: id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptDetailsFromAPI();
            this.$snackbar.success(i18n.t("ReceiptDetail.cancelRefundSuccess"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    saveAlbumImgs(images) {
      this.$store.dispatch("fullscreenLoading");
      let data = {
        bill_record_id: this.currentItem.id,
        imgs: []
      }
      if (images && images.length >0) {
        data.imgs = images.map((img) => img.img_name)

      }
      Receipt.uploadImg(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getReceiptDetailsFromAPI();
              this.$snackbar.success(i18n.t("ReceiptDetail.cancelRefundSuccess"));
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      )
    }
  },
};
</script>

<style>
</style>